import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GoogleCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  const processGoogleAuth = useCallback(async () => {
    const code = searchParams.get('code');
    if (!code) {
      navigate('/', { replace: true });
      return;
    }
    try {
      const redirectUri = window.location.origin + '/auth/google/callback';
      const response = await axios.post(
        `${BACKEND_URL}/api/auth/google/exchange`,
        { code, redirect_uri: redirectUri },
        { withCredentials: true }
      );
      const user = response.data;
      navigate('/dashboard', { state: { user }, replace: true });
    } catch (error) {
      navigate('/', { replace: true });
    }
  }, [navigate, searchParams]);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    processGoogleAuth();
  }, [processGoogleAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#1A4331] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-stone-600 font-medium">Completing authentication...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
